import qs from 'query-string';

import { message } from 'antd';
import { type ErrorResponse } from 'api';
import { getToken } from 'common/auth';
import { decrypt, encrypt } from './encryptUtil';

type Init = Omit<RequestInit, 'body'> & {
  params?: Record<string, unknown>;
  token?: string;
  body?: unknown;
};

const apiClient = async <R>(
  path: string,
  { body, headers, params, token, ...customInit }: Init = {},
  showMessage?: boolean
): Promise<R> => {
  const authToken = token ?? getToken();
  const username = sessionStorage.getItem('user')?.toString();

  const init = {
    ...customInit,
    headers: {
      ...(body
        ? // ? { 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': '*' }
          // : { 'Content-Type': 'application/text', 'Access-Control-Allow-Origin': '*' }),
          { 'Content-Type': 'text/plain', 'Access-Control-Allow-Origin': '*' }
        : { 'Content-Type': 'text/plain', 'Access-Control-Allow-Origin': '*' }),
      ...(authToken ? { Authorization: `Bearer ${authToken}` } : undefined),
      ...(username ? { Username: username } : undefined),
      ...headers,
    },
    body: body ? encrypt(JSON.stringify(body)) : undefined,
  };

  const url = buildURL(path, params);

  if (import.meta.env.DEV) {
    console.log('ApiClient Request:', { url, init });
  }

  let resp: any;

  let data: any;

  await fetch(url, init)
    .then(async (x) => {
      debugger;
      if (x.status != 401) {
        if (
          (x.url.indexOf('?') > 0 ||
            x.url.indexOf('getFeeCodeDetails') > 0 ||
            x.url.indexOf('getSystemDate') > 0) &&
          x.status == 200
        ) {
          await x.json().then((t) => {
            // console.log(t + "inside")
            // x.json = JSON.parse(decrypt(t.toString()));

            data = t;
            if (data != null && data['responseCode']?.toString() != '200') {
              const error: ErrorResponse = data as ErrorResponse;

              if (error.fieldErrors != null && error.fieldErrors.length > 0) {
                error.message = '';
                error.fieldErrors.forEach((x) => {
                  error.message = error.message.concat(x.defaultMessage.toString());
                });
              }

              if (!showMessage) {
                message.destroy();
                message.warning(error.message != '' ? error.message : t.error + ' ' + t.path);
              } else {
                return error.message != '' ? error.message : t.error + ' ' + t.path;
              }
              // eslint-disable-next-line @typescript-eslint/no-throw-literal
              // throw error;
            }
          });
        } else {
          await x.text().then((t) => {
            if (t != '' && t.indexOf('timestamp') <= 0) {
              if (decrypt(t.toString()).indexOf('{') >= 0) {
                try {
                  x.json = JSON.parse(decrypt(t.toString()));
                } catch (e) {
                  x.json = JSON.parse(t.toString());
                }
                resp = x;
                data = resp?.json;
              } else {
                resp = x;
                data = resp?.json;
                data.error = decrypt(t.toString());
              }

              const error: ErrorResponse = data as ErrorResponse;
              if (
                data != null &&
                data['responseCode'] != null &&
                data['responseCode']?.toString() != '200'
              ) {
                const error: ErrorResponse = data as ErrorResponse;

                if (error.fieldErrors != null && error.fieldErrors.length > 0) {
                  error.message = '';
                  error.fieldErrors.forEach((er) => {
                    error.message = error.message.concat(er.defaultMessage.toString());
                  });
                }
                if (!showMessage) {
                  message.destroy();
                  message.warning(error.message);
                } else {
                  return error.message;
                }
                // eslint-disable-next-line @typescript-eslint/no-throw-literal
                // throw error;
              }
              if (data.error != null) {
                if (!showMessage) {
                  message.destroy();
                  message.warning(data.error);
                } else {
                  return data.error;
                }
              }
              if (error.fieldErrors != null && error.fieldErrors.length > 0) {
                error.message = '';
                error.fieldErrors.forEach((x) => {
                  error.message = error.message.concat(x.defaultMessage.toString());
                });
                if (!showMessage) {
                  message.destroy();
                  message.warning(error.message);
                } else {
                  return error.message;
                }
              } else if (
                error.fieldErrors != null &&
                error.fieldErrors.length == 0 &&
                error.timestamp != null
              ) {
                if (!showMessage) {
                  message.destroy();
                  message.warning(error.message);
                } else {
                  return error.message;
                }
              }
            } else {
              data = JSON.parse(t);
              const error: ErrorResponse = data as ErrorResponse;

              if (error.fieldErrors != null && error.fieldErrors.length > 0) {
                error.message = '';
                error.fieldErrors.forEach((x) => {
                  error.message = error.message.concat(x.defaultMessage.toString());
                });
              }
              if (!showMessage) {
                message.destroy();
                message.warning(error.message != '' ? error.message : data.error);
              } else {
                return error.message != '' ? error.message : data.error;
              }
              // eslint-disable-next-line @typescript-eslint/no-throw-literal
            }
          });
        }
      } else {
        sessionStorage.clear();
        sessionStorage.setItem('isExpired', 'true');
        window.location.reload();
      }
    })
    .catch((e) => {
      if (!showMessage) {
        message.destroy();
        message.error(e.toString());
      }
    });

  return data as R;
};

export const buildURL = (path: string, params?: Record<string, unknown>) => {
  if (path.includes('loginmodule')) {
    path = import.meta.env.VITE_LOGIN_URL + path;
  } else if (path.includes('dashboardmodule')) {
    path = import.meta.env.VITE_DASHBOARD_URL + path;
  } else if (path.includes('agentmodule')) {
    path = import.meta.env.VITE_AGENT_URL + path;
  } else if (path.includes('usermanagement')) {
    path = import.meta.env.VITE_USERMANAGEMENT_URL + path;
  } else if (path.includes('mastermodule')) {
    path = import.meta.env.VITE_MASTER_URL + path;
  } else if (path.includes('nachmodule')) {
    path = import.meta.env.VITE_NACH_URL + path;
  }

  return path + (params && Object.keys(params).length > 0 ? `?${qs.stringify(params)}` : '');
};

export const get = <R>(path: string, init?: Init) => apiClient<R>(path, { ...init, method: 'GET' });

export const post = <R>(path: string, body?: unknown, showMessage?: boolean, init?: Init) =>
  apiClient<R>(path, { ...init, method: 'POST', body }, showMessage);

export const put = <R>(path: string, body?: unknown, init?: Init) =>
  apiClient<R>(path, { ...init, method: 'PUT', body });

export const patch = <R>(path: string, body?: unknown, init?: Init) =>
  apiClient<R>(path, { ...init, method: 'PATCH', body });

export const del = <R>(path: string, init?: Init) =>
  apiClient<R>(path, { ...init, method: 'DELETE' });
